import PropTypes from 'prop-types';
import { SegmentType } from './SegmentType';

export const FieldType = {
    DATE: SegmentType.DATE,
    DEPARTURE: SegmentType.DEPARTURE,
    ARRIVAL: SegmentType.ARRIVAL,
    PAX: 'PAX',
    ROOM: 'ROOM',
    SEPARATE_STAY: 'SEPARATESTAY',
};

export const FieldTypeProps = PropTypes.oneOf(Object.values(FieldType));
